module.exports = __webpack_public_path__ + "img/首页_u51.270cc64c.svg";